"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSingleDoubleClick = void 0;
const react_1 = require("react");
const SINGLE_CLICK_DELAY = 300;
const useSingleDoubleClick = (onClick, onDoubleClick) => {
    const [click, setClick] = (0, react_1.useState)(false);
    const singleClickTimer = (0, react_1.useRef)();
    const handleClick = () => {
        if (!click) {
            setClick(true);
            singleClickTimer.current = setTimeout(function () {
                setClick(false);
                onClick();
            }, SINGLE_CLICK_DELAY);
        }
        else {
            setClick(false);
            if (singleClickTimer.current) {
                clearTimeout(singleClickTimer.current);
            }
        }
    };
    const handleDoubleClick = () => {
        onDoubleClick();
    };
    return [handleClick, handleDoubleClick];
};
exports.useSingleDoubleClick = useSingleDoubleClick;
//# sourceMappingURL=useSingleDoubleClick.js.map